import { AssetConfig, DimensionType } from "./types";
import {
  ACTIVITY_BANNER_IMAGE_MAX_SIZE_KB,
  MAX_DEFAULT_ASSET_CONFIG_RATIO_4_1_IMAGE_SIZE_KB,
  MAX_DEFAULT_ASSET_UPLOAD_SIZE_KB,
  MAX_DEFAULT_IMAGE_SIZE_KB,
  MAX_DEFAULT_MULTI_FILE_UPLOAD_SIZE_KB,
  MAX_REIMBURSEMENT_RECEIPT_UPLOAD_SIZE_KB
} from "../../../utils/constants";

export const DEFAULT_ASSET_CONFIG: AssetConfig = {
  dimension: { height: 300, width: 600 },
  maxSize: MAX_DEFAULT_ASSET_UPLOAD_SIZE_KB,
  aspectRatio: "2:1"
};

export const DEFAULT_MULTI_FILE_ASSET_CONFIG: AssetConfig = {
  dimension: { height: 300, width: 600 },
  maxSize: MAX_DEFAULT_MULTI_FILE_UPLOAD_SIZE_KB,
  aspectRatio: "2:1"
};

export const DEFAULT_PROGRAM_HEADER_IMAGE_CONFIG: AssetConfig = {
  dimension: { height: 300, width: 600 },
  maxSize: MAX_DEFAULT_ASSET_UPLOAD_SIZE_KB,
  aspectRatio: "2:1"
};
export const DEFAULT_PROGRAM_ICON_IMAGE_CONFIG: AssetConfig = {
  dimension: { height: 150, width: 150 },
  maxSize: MAX_DEFAULT_IMAGE_SIZE_KB,
  aspectRatio: "1:1"
};

export const REIMBURSEMENT_RECEIPT_CONFIG: AssetConfig = {
  dimension: { height: 200, width: 200 },
  maxSize: MAX_REIMBURSEMENT_RECEIPT_UPLOAD_SIZE_KB,
  aspectRatio: "1:1"
};

export const DEFAULT_SELECTION_CARD_DIMENSION: DimensionType = {
  height: 200,
  width: 400
};

export const DEFAULT_SELECTABLE_CARD_DIMENSION: DimensionType = {
  height: 200,
  width: 400
};

export const ORGANIZATION_LOGO_ASSET_CONFIG: AssetConfig = {
  dimension: { width: 150, height: 75 },
  maxSize: MAX_DEFAULT_IMAGE_SIZE_KB,
  aspectRatio: "2:1"
};

export const ICON_CONFIG: AssetConfig = {
  dimension: { height: 34, width: 34 },
  maxSize: MAX_DEFAULT_IMAGE_SIZE_KB,
  aspectRatio: "1:1"
};

export const ASSOCIATED_PROGRAM_ACTIVITY_IMAGE_CONFIG: AssetConfig = {
  dimension: { height: 300, width: 600 },
  maxSize: ACTIVITY_BANNER_IMAGE_MAX_SIZE_KB,
  aspectRatio: "2:1"
};

export const DEFAULT_ASSET_CONFIG_RATIO_4_1: AssetConfig = {
  dimension: { width: 600, height: 150 },
  maxSize: MAX_DEFAULT_ASSET_CONFIG_RATIO_4_1_IMAGE_SIZE_KB,
  aspectRatio: "4:1"
};

export const DEFAULT_ASSET_CONFIG_DIGITAL_AD_WEB_DASHBOARD_FOR_SINGLE_BLOCK: AssetConfig = {
  dimension: { width: 150, height: 250 },
  maxSize: MAX_DEFAULT_ASSET_UPLOAD_SIZE_KB,
  aspectRatio: "3:5"
};
export const DEFAULT_ASSET_CONFIG_DIGITAL_AD_WEB_DASHBOARD_FOR_DOUBLE_BLOCK: AssetConfig = {
  dimension: { width: 150, height: 375 },
  maxSize: MAX_DEFAULT_ASSET_UPLOAD_SIZE_KB,
  aspectRatio: "2:5"
};
export const DEFAULT_ASSET_CONFIG_DIGITAL_AD_WEB_DASHBOARD_FOR_TRIPPLE_BLOCK: AssetConfig = {
  dimension: { width: 150, height: 750 },
  maxSize: MAX_DEFAULT_ASSET_UPLOAD_SIZE_KB,
  aspectRatio: "1:5"
};

export const DEFAULT_ASSET_CONFIG_DIGITAL_AD_WEB_PROFILE_FORM: AssetConfig = {
  dimension: { width: 300, height: 500 },
  maxSize: MAX_DEFAULT_ASSET_UPLOAD_SIZE_KB,
  aspectRatio: "3:5"
};

export const DEFAULT_ASSET_CONFIG_DIGITAL_AD_MOBILE_DASHBOARD: AssetConfig = {
  dimension: { width: 640, height: 100 },
  maxSize: MAX_DEFAULT_ASSET_UPLOAD_SIZE_KB,
  aspectRatio: ""
};
